import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import { getProducts } from '../../services/product.service';

export const getProductsQueryKey = 'getProducts';
export const useProductsList = () => useQuery([getProductsQueryKey], () => getProducts()
  .then((result: AxiosResponse<string[]>) => result.data), {
  refetchOnWindowFocus: false, retry: false,
});
